import React, { useContext, useState } from 'react'
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { LikutModals } from '../../../../../modules/Context/CefiNum';
import { vibrationFunc } from '../../../../../modules/vibrationModule';
import { FormShell, FormFooter } from '../../../../../generic/ui/FormLayout'
import IconTextField from '../../../../../generic/ui/Input/IconTextField'
import { AccentButton } from '../../../../../generic/ui/Button'
import { useTranslation } from 'react-i18next';

export default function MoreThenNeed({ resons }) {
    const [t] = useTranslation('buttons')
    const artPass = useSelector(item => item.defaults.defaults.filter(e => e.Int_ID === 577)[0].Text_Value?.trim())

    const [resonState, setResonState] = useContext(LikutModals);
    const [resonId, setResonId] = useState(null);
    const [inputPass, setInputPass] = useState('');
    const [isPassError, setIsPassError] = useState(false);

    const acceptFunc = () => {
        if (!resonId) return
        // if cant find good in order
        if (resonId === 2 && resons.num === 1) {
            if (inputPass === artPass) {
                resonState.action(true);
                setResonState({
                    ...resonState,
                    'active': false,
                    'props': {
                        ...resonState.props,
                        resonID: resonId,
                        problemID: resons.num
                    }
                })
            } else {

            }
        }

        else if (resonId === 5) {
            resonState?.props?.setRowModal(true);
            setResonState({
                ...resonState,
                'active': false,
                'props': {
                    ...resonState.props,
                    resonID: resonId,
                    problemID: resons.num
                }
            })
        }

        else {

            if (resonId === 2) {
                if (inputPass === artPass) {
                    resonState.action(resons.num, resonId);
                    setResonState({ ...resonState, 'active': false });
                }
                // atamat mishkal =>
            } else if (resonId === 1) {
                // calc itra by order weigth
                resonState?.props?.setPacks(resonState?.props?.calcFunc())


                setResonState({
                    ...resonState,
                    'active': false,
                    'props': {
                        ...resonState.props,
                        resonID: resonId,
                        problemID: resons.num
                    }
                })

            }

            else {
                resonState.action(resons.num, resonId);
                setResonState({ ...resonState, 'active': false });
            }
        }
    }

    const visibleResons = resonState?.props?.packType === '2' ? // if pack = ihidot =>
        resons?.resons?.filter(item => item.id !== 1)
        : resons?.resons

    const handlePassKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            if (artPass !== e.target.value) {
                vibrationFunc();
                setIsPassError(true);
                setTimeout(() => {
                    setIsPassError(false)
                }, 2000)
                return
            }
            else {
                acceptFunc()
            }
        }
    }

    return (
        <FormShell>
            <ReasonList role='listbox'>
                {
                    visibleResons?.map((item) => (
                        <ReasonOption
                            key={item.id}
                            type='button'
                            role='option'
                            aria-selected={resonId === item.id}
                            $selected={resonId === item.id}
                            onClick={() => setResonId(item.id)}
                        >
                            {item.desc}
                        </ReasonOption>
                    ))
                }
            </ReasonList>
            {
                resonId === 2 &&
                <IconTextField
                    type='password'
                    autoComplete='new-password'
                    placeholder='סיסמה'
                    error={isPassError}
                    onChange={e => { setInputPass(e.target.value) }}
                    onKeyPress={handlePassKeyPress}
                />
            }
            <FormFooter>
                <AccentButton
                    type='button'
                    onClick={acceptFunc}
                    disabled={!resonId}
                    fullWidth={false}
                >
                    {t("save")}
                </AccentButton>
            </FormFooter>
        </FormShell>
    )
}

const ReasonList = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    direction: rtl;
`

const ReasonOption = styled.button`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: right;
    padding: 0.75rem 0.875rem;
    border-radius: 0.875rem;
    border: 1px solid ${({ theme, $selected }) => ($selected ? theme.colors.accent : theme.colors.line)};
    background: ${({ theme, $selected }) => ($selected ? theme.colors.accentSoft : theme.colors.surface)};
    color: ${({ theme }) => theme.colors.ink};
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: ${({ theme }) => theme.text.md};
    font-weight: ${({ $selected }) => ($selected ? 600 : 400)};
    cursor: pointer;
    transition: all ${({ theme }) => theme.motion.fast} ease;

    &:hover {
        border-color: ${({ theme, $selected }) => ($selected ? theme.colors.accent : theme.colors.inputBorderHover)};
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.md};
    }
`
